import { useEffect } from "react";

const useSetPageTitle = (pageTitle, currentPromo = null) => {
    useEffect(() => {
        document.title = `${currentPromo?.titulo ?? 'Promos Juntos+'} | ${pageTitle}`;
    }, [pageTitle, currentPromo]);
}

export default useSetPageTitle;